__turbopack_context__.v({
  "centerStars": "ProductReviews-module-scss-module__JC-U_q__centerStars",
  "linkDescription": "ProductReviews-module-scss-module__JC-U_q__linkDescription",
  "partialGreenReviewStar": "ProductReviews-module-scss-module__JC-U_q__partialGreenReviewStar",
  "partialReviewStarContainer": "ProductReviews-module-scss-module__JC-U_q__partialReviewStarContainer",
  "productInfoAccordionHeading": "ProductReviews-module-scss-module__JC-U_q__productInfoAccordionHeading",
  "reviewsStar": "ProductReviews-module-scss-module__JC-U_q__reviewsStar",
});
